import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../../../../service/auth.service';

@Component({
  selector: 'app-successRegistration',
  templateUrl: './successRegistration.component.html',
  styleUrls: ['./successRegistration.component.css']
})
export class SuccessRegistrationComponent implements OnInit {
  token: string
  success: boolean
  errorMessage: string

  //translations
  err1: string
  err2: string
  err3: string

  constructor(
    private route: ActivatedRoute,
    private authService: AuthService,
    public translate: TranslateService,
    private router: Router) { 
      this.getTranslatedStrings()
    }

  getTranslatedStrings() {
    this.translate.get(['REG_ERR6', 'REG_ERR7', 'REG_ERR8'])
      .subscribe(translations => {
        this.err1 = translations['REG_ERR6']
        this.err2 = translations['REG_ERR7']
        this.err3 = translations['REG_ERR8']
      })
  }


  ngOnInit() {

    this.route.params.subscribe(paramsId => {
      this.token = paramsId['token']
    });

    this.authService.validateEmail({ token: this.token })
      .then(resp => {
        this.success = true
        setTimeout(() => {
          this.router.navigate(['/logon'])
        }, 4000)
      })
      .catch((err) => {
        this.success = false
        if (err.status === 409) {
          //ALREADY CONFIRMED
          this.errorMessage = this.err1
        }
        else if (err.status === 401) {
          //EXPIRED LINK
          this.errorMessage = this.err2

        }
        else {
          //GENERIC ERROR
          this.errorMessage = this.err3
        }
      })

  }

  capitalizeFirstLetter = (s: string) => {
    return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase()
  }

}
